import { createUseStyles } from 'react-jss';
import type { Theme } from '@wds/styles';

const useStyles = createUseStyles(
  ({ spacing, border, breakpoints, palette }: Theme) => ({
    wrapper: {
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      padding: '150px 0',
    },
    messageWrapper: {
      minWidth: '550px',
      margin: 0,
      position: 'unset',
    },
    cardWrapper: {
      marginTop: spacing['4'],
    },
    linkList: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      margin: 0,
      padding: `${spacing['6']}px 10% 0`,
      listStyleType: 'none',

      '& > li': {
        flexGrow: 1,
        flexBasis: 'auto',
        textAlign: 'center',
        borderRight: border.border,
        backgroundColor: palette.text.light,

        '&:last-child': {
          borderRight: 'none',
        },
      },
    },
    pageWrapper: {
      backgroundColor: palette.background.main,
    },
    pageLogoLink: {
      [`@media screen and (max-width: ${breakpoints.sm}px)`]: {
        position: 'relative',
        display: 'block',
        top: 0,
        left: 0,
      },

      [`@media screen and (min-width: ${breakpoints.sm}px)`]: {
        position: 'fixed',
        top: spacing['5'],
        left: spacing['5'],
        width: 200,
        height: 30,
        margin: 0,
      },
    },
  })
);

export default useStyles;
